import './SyncView.scss';

import { coreActions } from '@sonar-software/sonar-core';
import { LoadingArovy } from '@ui/general';
import { useNavigate } from 'react-router-dom';

import { GatewayCard, GatewayContent } from '../../general';
import { ImportStatus, ONBOARDING_SYNC_COPY } from '@sonar-software/sonar-ts-constants';
import React, { PropsWithChildren, useEffect } from 'react';
import { useAction, useOnboardingProgress, useSalesforceSync } from '@hooks';

export interface SyncViewProps {
	pre?: React.ReactNode;
	title: string;
}

export const SyncView: React.FC<PropsWithChildren<SyncViewProps>> = ({ children, pre, title }) => {
	const navigate = useNavigate();
	const { status, resetSync } = useSalesforceSync(true);
	const { updateProgress } = useOnboardingProgress();

	const refreshOrgs = useAction(coreActions.requestGetCoreOrganizationsAll);

	useEffect(() => {
		if (status?.status === ImportStatus.Completed) {
			refreshOrgs();
			resetSync();
			updateProgress({
				currentlyRunningSfdcImportId: undefined,
				isSalesforceSynced: true,
				latestSuccessfulSfdcImportId: status.id
			});
			navigate('/', { replace: true });
		}
	}, [ navigate, refreshOrgs, resetSync, status?.id, status?.status, updateProgress ]);

	return (
		<GatewayContent>
			<GatewayCard
				className='sync-view'
				pre={ pre }
				title={ title }>
				{ children }
				<LoadingArovy />
				<p className='sync-status'>{ status?.logs[ 0 ]?.text ?? ONBOARDING_SYNC_COPY.CONNECTING_FIRST_TIME }</p>
				<div className='sub-info'>{ ONBOARDING_SYNC_COPY.CLOSE_THIS_TAB }</div>
			</GatewayCard>
		</GatewayContent>
	);
};
